define([
	"dojo/_base/declare",
	"dojo/when",
	"csi/action/NewRefNodeMixin"
], function(declare, when, NewRefNodeMixin) {

	return declare(NewRefNodeMixin, {
		/**
		 * If no other postprocessing is done, then use default behavior to add new node to view
		 * @returns 
		 */
		_newPostProcess() {
			const {m_proxy, refNode, usedReactDialog, widget} = this;

			if (this.bEditHeading == null) {
				this.bEditHeading = !m_proxy && !usedReactDialog;
			}

			const dfd = this.inherited(arguments);
			if (dfd) {
				return dfd;
			}

			// add block for each new node
			const nodes = this.getNewNodes();
			const refNodeNext = refNode || widget.getRefNodes()[0];

			when(widget.addBlocks(nodes, refNodeNext, true), (refNodes) => {
				this._newPostProcessRefNode(refNodes[0]);
			});
		}
	});
});